<template>
  <!-- eslint-disable vue/no-template-shadow -->
  <!-- eslint-disable vue/no-use-v-if-with-v-for -->
  <div class="page--brands">
    <div class="container">
      <div class="row brand-list">
        <div class="col-sm-12">
          <h4 class="page-heading">Brands</h4>
        </div>
        <div class="col-sm-9">
          <div class="brand-content">
            <div class="menu-bar">
              <div class="search">
                <input
                  v-model="keyword"
                  type="text"
                  name="search"
                  autocomplete="off"
                  placeholder="Search Brand..."
                  class="input-search"
                  @keyup="searchQuery"
                />
                <span class="icon-search"></span>
              </div>
              <div class="search-by-alpha">
                <template v-for="(alph, key) in alphabets">
                  <router-link
                    v-if="alph === '1'"
                    :key="key"
                    :to="'/brands/' + alph"
                    class="brand-tag"
                    :class="{
                      active: letter === alph || letter === alph.toLowerCase(),
                    }"
                    >{{ '#' }}</router-link
                  >
                  <router-link
                    v-else
                    :key="key"
                    :to="'/brands/' + alph.toLowerCase()"
                    class="brand-tag"
                    :class="{
                      active: letter === alph || letter === alph.toLowerCase(),
                    }"
                    >{{ alph }}</router-link
                  >
                </template>
              </div>
            </div>
            <div class="content-page-brand">
              <div v-if="isFinishLoadingAllBrand">
                <div v-for="(value, key) in allBrand" v-if="value.length" :key="key" class="list-letter-brand">
                  <!--  <h4 class="brand-letter" :id="'brand-letter-'+key">{{key}}</h4> -->
                  <div class="brand-alpaha-item">
                    <h5>Brands</h5>
                    <h4 :id="'brand-letter-' + key">{{ key }}</h4>
                    <p class="allresult">{{ totalResult }} Results</p>
                  </div>

                  <div class="list-brand-logo">
                    <div v-for="(brand, key) in value" :key="key" class="column-brand-logo">
                      <router-link
                        :key="key"
                        :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`"
                        class="brand-logo"
                      >
                        <figure :title="brand.name">
                          <template v-if="brand.logo">
                            <img
                              :src="mainImage(brand.logo)"
                              alt="SOCO"
                              onerror="this.src='/assets/img/default_img_brand.svg'"
                              class="brand-logo__img"
                            />
                          </template>
                          <template v-else>
                            <img src="/assets/img/default_img_brand.svg" class="brand-logo__img" alt="SOCO" />
                          </template>
                        </figure>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <h4>No Brands</h4>
                </div>
              </div>
              <div v-else>
                <div v-for="i in 4" :key="`${i}_GMP_1`" style="margin-bottom: 30px">
                  <GFMP
                    :key="`${i}_GMP_1`"
                    :styles="{
                      minHeight: '20px',
                      marginBottom: '16px',
                      width: '100%',
                    }"
                  />
                  <GFMP
                    :key="`${i}_GMP_2`"
                    :styles="{
                      minHeight: '20px',
                      marginBottom: '16px',
                      width: '90%',
                    }"
                  />
                  <GFMP
                    :key="`${i}_GMP_3`"
                    :styles="{
                      minHeight: '20px',
                      marginBottom: '16px',
                      width: '80%',
                    }"
                  />
                  <GFMP
                    :key="`${i}_GMP_4`"
                    :styles="{
                      minHeight: '600px',
                      marginBottom: '16px',
                      width: '100%',
                    }"
                  />
                </div>
              </div>
            </div>

            <infinite-loading v-if="isShowingInfiniteLoading" @infinite="infiniteHandler">
              <div slot="no-more"></div>
              <div slot="no-results"></div>
              <div slot="spinner"><GLoaderSpin text="Load brand.." /></div>
            </infinite-loading>
          </div>
        </div>
        <div class="col-sm-3">
          <popularBrands />
          <AddThoughts
            button-text="Write Review"
            button-redirect-url="/review/add"
            copywriting="Ingin berkontribusi menambah review dengan konten yang menarik?"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import popularBrands from '@/components/sidebar/popularBrands';
import AddThoughts from '@/components/global/add-thoughts/add-thoughts';

let infiniteLoadingStateReference;

export default {
  name: 'brand-letter',
  components: {
    popularBrands,
    AddThoughts,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['letter'],
  data() {
    return {
      alphabets: [
        '1',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ],
      isFinishLoadingAllBrand: false,
      allBrand: [],
      keyword: '',
      totalResult: 0,
      selectedLetter: 'A',
      skip: 0,
      limit: 10,
    };
  },
  computed: {
    isShowingInfiniteLoading() {
      return this.$SO.size(this.allBrand) && this.totalResult >= this.limit;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
  },
  watch: {
    letter() {
      const doResetInfiniteLoadingStateAndLoadMoreParams = Boolean(infiniteLoadingStateReference);

      if (doResetInfiniteLoadingStateAndLoadMoreParams) {
        infiniteLoadingStateReference.reset();
        this.skip = 0;
      }
      this.getBrands();
    },
  },
  created() {
    this.getBrands();
  },
  methods: {
    toLetter(letter) {
      this.selectedLetter = letter;
      const topPos = document.getElementById('brand-letter-' + letter).offsetTop;
      const containerOffset = document.getElementById('brand-value').offsetTop;
      document.getElementById('brand-value').scrollTop = topPos - containerOffset;
    },
    searchQuery(e) {
      if (this.keyword) {
        this.$MS_SOCO_PUBLIC_API_URL
          .get('/brands', {
            params: {
              fields: 'my_soco_sql_id name logo',
              limit: 10,
              filter: {
                name: { $regex: '^' + this.keyword, $options: 'i' },
              },
            },
          })
          .then((res) => {
            // const data = res.data.data;
            this.allBrand = {};
            this.allBrand[this.keyword[0]] = res.data.data;
          });
      } else {
        this.getBrands();
      }
    },
    getBrands() {
      let filter = {
        letters: [this.letter],
      };
      if (this.letter === '1') {
        filter = {
          letters: ['#'],
        };
      }
      this.isFinishLoadingAllBrand = false;
      this.$MS_SOCO_PUBLIC_API_URL
        .get('/brands/letter', {
          params: {
            fields: 'my_soco_sql_id name logo',
            limit: this.limit,
            filter: filter,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.allBrand = response.data.data;
            if (this.letter === '1') {
              this.totalResult = response.data.data['#'].length;
            } else {
              this.totalResult = response.data.data[this.letter].length;
            }
          } else {
            this.allBrand = [];
            this.totalResult = 0;
          }
          this.isFinishLoadingAllBrand = true;
        })
        .catch((err) => {
          console.log(err);
          this.isFinishLoadingAllBrand = true;
          this.allBrand = [];
          this.totalResult = 0;
        });
    },
    infiniteHandler($state) {
      let filter = {
        letters: [this.letter],
      };
      const dontHaveReferenceStateOfInfinityLoading = !infiniteLoadingStateReference;

      if (dontHaveReferenceStateOfInfinityLoading) {
        infiniteLoadingStateReference = $state;
      }

      if (this.letter === '1') {
        filter = {
          letters: ['#'],
        };
      }

      this.skip += this.limit;

      this.$MS_SOCO_PUBLIC_API_URL
        .get('/brands/letter', {
          params: {
            fields: 'my_soco_sql_id name logo',
            limit: this.limit,
            filter: filter,
            skip: this.skip,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (this.$SO.size(response.data.data[this.letter])) {
              this.allBrand[this.letter] = this.allBrand[this.letter].concat(response.data.data[this.letter]);

              if (this.letter === '1') {
                this.totalResult = this.allBrand['#'].length;
              } else {
                this.totalResult = this.allBrand[this.letter].length;
              }
              $state.loaded();
            } else {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch((err) => {
          console.log(err);
          $state.complete();
        });
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=150' : 'w=144',
        image: src,
      });
    },
  },
};
</script>
<!--
<style lang="scss">
@import "brandsLetter";
</style> -->
